import React from 'react';
import classNames from 'classnames';
import { BASE_IMG_URL } from '../../../../images/imageUrls';
import { getProtectedEventHandlers, protectedMediaStyle } from '../../../../utils/contentProtection';
import styles from './index.module.scss';

interface ThreadDetailVideoProps {
    src: string;
    poster?: string;
    isProtected: boolean;
    beforeContent?: boolean;
}

const ThreadDetailVideo = ({ src, poster, isProtected, beforeContent = false }: ThreadDetailVideoProps) => {
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const [hasStarted, setHasStarted] = React.useState(false);
    const { onContextMenu, onDragStart } = getProtectedEventHandlers(isProtected);
    const protectedHandlers = { onContextMenu, onDragStart };

    return (
        <div className={classNames(styles.videoBox, beforeContent && styles.videoBeforeContent)} {...protectedHandlers}>
            <video
                ref={videoRef}
                src={src}
                poster={poster}
                className={styles.video}
                preload="auto"
                playsInline
                controls={hasStarted}
                controlsList={isProtected ? 'nodownload' : undefined}
                onPlay={() => setHasStarted(true)}
                style={isProtected ? protectedMediaStyle : undefined}
                {...protectedHandlers}
            >
                您的浏览器不支持 video 标签。
            </video>
            {!hasStarted && (
                <button
                    type="button"
                    className={styles.videoPlayButton}
                    aria-label="播放视频"
                    onClick={() => videoRef.current?.play().catch(() => {})}
                >
                    <img src={`${BASE_IMG_URL}/common/play.png`} alt="" />
                </button>
            )}
        </div>
    );
};

export default ThreadDetailVideo;
